/**
 * External dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

export const paymentReturn = (
	<SVG width="48" height="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
		<Path
			d="M38.8891 30.1885V17.8108C38.8891 15.3441 37.4891 13.9663 35.0224 13.9663H12.978C10.5113 13.9663 9.11133 15.3441 9.11133 17.8108V30.1885C9.11133 32.6552 10.5113 34.033 12.978 34.033H35.0224C37.4891 34.033 38.8891 32.6552 38.8891 30.1885Z"
			fill="var(--wpds-color-background-surface-neutral-weak, #F0F0F0)"
		/>
		<Path
			d="M38.8891 17.9883H9.11133V21.9438H38.8891V17.9883Z"
			fill="var(--wpds-color-stroke-surface-neutral-weak, #E0E0E0)"
		/>
		<Path
			d="M26.7778 40.5333L16.6 33.0667V37.5556H15.4889C10.2444 37.5556 5.97778 33.2889 5.97778 28.0444V26V26.9333C5.97778 24.4889 5.88889 22 2.75556 22H0V27.9444C0 36.5778 6.95555 43.5333 15.4889 43.5333H16.6V48L26.7778 40.5333Z"
			fill="var(--wpds-color-stroke-surface-neutral-weak, #E0E0E0)"
		/>
		<Path
			d="M21.2227 7.46667L31.4004 14.9333V10.4444H32.5115C37.756 10.4444 42.0227 14.7111 42.0227 19.9556V22V21.0667C42.0227 23.5111 42.1115 26 45.2449 26H48.0004V20.0556C48.0004 11.4222 41.0449 4.46667 32.5115 4.46667H31.4004V0L21.2227 7.46667Z"
			fill="var(--wpds-color-stroke-surface-neutral-weak, #E0E0E0)"
		/>
	</SVG>
);
